import { SavedFilterField } from './saved-filter-field';

export enum FilterMatch {
    All = 'All',
    Any = 'Any'
}

export enum FilterType {
    Simple = 'Simple',
    Advanced = 'Advanced'
}

export interface SavedFilter {
    type: FilterType;
    match: FilterMatch;
    not: boolean;
    fields: SavedFilterField[];
}
